import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { breakpoints } from '../../helpers/utils';
import { navbarBreakPoint, topNavbarBreakpoint } from '../../config';
import AppContext from '../../context/Context';
import { NavItem } from 'reactstrap';
import { Link } from 'react-scroll'

const NavbarTopDropDownMenusLanding = ({ setNavbarCollapsed, setShowBurgerMenu }) => {
  const { isCombo, isTopNav } = useContext(AppContext);

  const handleSetNavbarCollapsed = () => {
    const windowWidth = window.innerWidth;
    isTopNav && !isCombo && windowWidth < breakpoints[topNavbarBreakpoint] && setNavbarCollapsed(false);
    isCombo && windowWidth < breakpoints[navbarBreakPoint] && setShowBurgerMenu(false);
  };

  return <>
    <NavItem onClick={handleSetNavbarCollapsed}>
      <Link className="nav-link cursor-pointer d-lg-block" to='services'
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}>
        <span className='nav-link'>
          Servicios
        </span>
      </Link>
    </NavItem>
    <NavItem onClick={handleSetNavbarCollapsed}>
      <Link className="nav-link cursor-pointer d-lg-block" to='calculator'
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}>
        <span className='nav-link'>
          Calculadora
        </span>
      </Link>
    </NavItem>
    <NavItem onClick={handleSetNavbarCollapsed}>
      <Link className="nav-link cursor-pointer d-lg-block" to='faq'
        spy={true}
        smooth={true}
        offset={-70}
        duration={500}>
        <span className='nav-link'>
          FAQ
        </span>
      </Link>
    </NavItem>
    <NavItem onClick={handleSetNavbarCollapsed}>
      <Link className="nav-link cursor-pointer d-lg-block" to='contact'
        spy={true}
        smooth={true}
        offset={-65}
        duration={500}>
        <span className='nav-link'>
          Contacto
        </span>
      </Link>
    </NavItem>
  </>
}

NavbarTopDropDownMenusLanding.propTypes = { setNavbarCollapsed: PropTypes.func.isRequired };

export default NavbarTopDropDownMenusLanding;